import React, { Fragment } from 'react'
import { Dialog, Transition } from '@headlessui/react'
import propTypes from 'prop-types';

export const CustomModalRoot =React.memo( (props) => {
    const { isOpenDialogue } = props;
    const { isOpen, onCloseDialog, children ,className } = isOpenDialogue;
     
    const closePopup = () => onCloseDialog()
    return (
        <Transition.Root show={isOpen} as={Fragment}>
            <Dialog as="div" className={`relative z-10`}  onClose={closePopup}>
                <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity backdrop-blur-sm backdrop-brightness-75" />
                </Transition.Child>

                <div className="fixed inset-0 z-10 overflow-y-auto">
                    <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                            enterTo="opacity-100 translate-y-0 sm:scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        >
                            <Dialog.Panel className={`relative transform overflow-y-visible rounded-lg text-left shadow-xl transition-all ${className}`}>
                                {children}
                            </Dialog.Panel>
                        </Transition.Child>
                    </div>
                </div>
            </Dialog>
        </Transition.Root>
    )
})

CustomModalRoot.propTypes = {
    isOpenDialogue: propTypes.shape({
        isOpen: propTypes.bool,
        onCloseDialog: propTypes.func,
        children: propTypes.node,
        className: propTypes.string
    })
}

CustomModalRoot.defaultProps = {
    isOpenDialogue: {
        isOpen: false,
        children: <></>,
        className: 'sm:my-8 sm:w-full sm:max-w-620 '
    }
}